import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { SpaceRoleItem } from "@ServerTypes/spaces/space.schema";

const spaceRolesSlice = createSlice({
  name: "getSpaceRoles",
  initialState: [] as SpaceRoleItem[],
  reducers: {
    setSpaceRoles: (_state: SpaceRoleItem[], action: PayloadAction<SpaceRoleItem[]>) => action.payload,
  },
});

export const { setSpaceRoles } = spaceRolesSlice.actions;

export const getSpaceRoles = spaceRolesSlice.reducer;

export default spaceRolesSlice.reducer;
